import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	a11YSidebarDividerDescription: {
		id: 'servicedesk-insight-object-schema-page.common.object-schema-page-layout.a-11-y-sidebar-divider-description',
		defaultMessage: 'Resize Assets side navigation panel',
		description: 'Visually hidden lable to make resizing divider accessible for screen reader',
	},
});
